import api from '@/api/index.js'

const public_transport = {
  state: {
    loading: false,
    vehicles: [],
    error: null
  },

  mutations: {
    SET_VEHICLES_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_VEHICLES: (state, vehicles) => {
      state.vehicles = vehicles
      state.loading = false;
    },
    SET_VEHICLES_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    GetPTSchedules({commit}) {
      commit('SET_VEHICLES_LOADING', true)
      return api.get('schedules?limit=0&offset=0')
        .then((response) => {
          commit('SET_VEHICLES', response)
          commit('SET_VEHICLES_LOADING', false)
        })
        .catch((error) => {
          commit('SET_VEHICLES_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default public_transport
